// import { useState, useEffect, useRef } from "react";
// import { motion } from "framer-motion";
// import { FiHeart, FiChevronLeft, FiChevronRight } from "react-icons/fi";
// import VisaDetailsModal from "./VisaDetailsModal";

// const CountryCardsSection = () => {
//   const [selectedCountry, setSelectedCountry] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [autoPlay, setAutoPlay] = useState(true);
//   const [cardsToShow, setCardsToShow] = useState(4);
//   const [countries, setCountries] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const sliderRef = useRef(null);

//   // Static fallback data
//   // const staticCountries = [
//   //   {
//   //     id: 1,
//   //     name: "Thailand",
//   //     visaCount: "32K Visas",
//   //     image:
//   //       "https://images.unsplash.com/photo-1541417904950-b855846fe074?auto=format&fit=crop&w=800&q=80",
//   //     date: "04 Dec, 12:18 PM",
//   //     flag: "🇹🇭",
//   //     description: "Land of smiles with tropical beaches and rich culture",
//   //     visaTypes: [
//   //       {
//   //         id: 1,
//   //         name: "30 Days Tourist Visa",
//   //         type: "Single Entry",
//   //         validity: "30 Days",
//   //         duration: "30 Days",
//   //         processingTime: "7 Business Days",
//   //         estimatedDate: "30-09-2025",
//   //         price: "₹2790",
//   //         express: false,
//   //         popular: true,
//   //       },
//   //       {
//   //         id: 2,
//   //         name: "60 Days Tourist Visa",
//   //         type: "Single Entry",
//   //         validity: "60 Days",
//   //         duration: "60 Days",
//   //         processingTime: "10 Business Days",
//   //         estimatedDate: "02-10-2025",
//   //         price: "₹4500",
//   //         express: false,
//   //         popular: false,
//   //       },
//   //     ],
//   //   },
//   //   {
//   //     id: 2,
//   //     name: "Vietnam",
//   //     visaCount: "15K Visas",
//   //     image:
//   //       "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=800&q=80",
//   //     date: "04 Dec, 11:30 PM",
//   //     flag: "🇻🇳",
//   //     description: "Vibrant cities, stunning landscapes, and delicious cuisine",
//   //     visaTypes: [
//   //       {
//   //         id: 1,
//   //         name: "30 Days E-Visa",
//   //         type: "Single Entry",
//   //         validity: "30 Days",
//   //         duration: "30 Days",
//   //         processingTime: "5 Business Days",
//   //         estimatedDate: "28-09-2025",
//   //         price: "₹2500",
//   //         express: false,
//   //         popular: true,
//   //       },
//   //     ],
//   //   },
//   //   {
//   //     id: 3,
//   //     name: "India",
//   //     visaCount: "10K Visas",
//   //     image:
//   //       "https://images.pexels.com/photos/2387871/pexels-photo-2387871.jpeg",
//   //     date: "05 Dec, 10:00 AM",
//   //     flag: "🇮🇳",
//   //     description:
//   //       "Diverse culture, ancient history, and spiritual destinations",
//   //     visaTypes: [
//   //       {
//   //         id: 1,
//   //         name: "30 Days Tourist E-Visa",
//   //         type: "Single Entry",
//   //         validity: "30 Days",
//   //         duration: "30 Days",
//   //         processingTime: "4 Business Days",
//   //         estimatedDate: "27-09-2025",
//   //         price: "₹3500",
//   //         express: false,
//   //         popular: true,
//   //       },
//   //     ],
//   //   },
//   //   {
//   //     id: 4,
//   //     name: "Australia",
//   //     visaCount: "18K Visas",
//   //     image:
//   //       "https://images.pexels.com/photos/2845013/pexels-photo-2845013.jpeg",
//   //     date: "07 Dec, 09:40 AM",
//   //     flag: "🇦🇺",
//   //     description: "Stunning landscapes, unique wildlife, and vibrant cities",
//   //     visaTypes: [
//   //       {
//   //         id: 1,
//   //         name: "Tourist Visa (subclass 600)",
//   //         type: "Multiple Entry",
//   //         validity: "1 Year",
//   //         duration: "3 Months per stay",
//   //         processingTime: "20 Business Days",
//   //         estimatedDate: "15-10-2025",
//   //         price: "₹9500",
//   //         express: false,
//   //         popular: true,
//   //       },
//   //     ],
//   //   },
//   //   {
//   //     id: 5,
//   //     name: "Japan",
//   //     visaCount: "25K Visas",
//   //     image:
//   //       "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&w=800&q=80",
//   //     date: "08 Dec, 02:15 PM",
//   //     flag: "🇯🇵",
//   //     description: "Cherry blossoms, ancient temples, and modern technology",
//   //     visaTypes: [
//   //       {
//   //         id: 1,
//   //         name: "90 Days Tourist Visa",
//   //         type: "Single Entry",
//   //         validity: "90 Days",
//   //         duration: "90 Days",
//   //         processingTime: "7 Business Days",
//   //         estimatedDate: "30-09-2025",
//   //         price: "₹4500",
//   //         express: false,
//   //         popular: true,
//   //       },
//   //     ],
//   //   },
//   //   {
//   //     id: 6,
//   //     name: "United States",
//   //     visaCount: "45K Visas",
//   //     image:
//   //       "https://images.unsplash.com/photo-1485738422979-f5c462d49f74?auto=format&fit=crop&w=800&q=80",
//   //     date: "09 Dec, 03:30 PM",
//   //     flag: "🇺🇸",
//   //     description:
//   //       "Diverse landscapes, iconic cities, and endless opportunities",
//   //     visaTypes: [
//   //       {
//   //         id: 1,
//   //         name: "B1/B2 Tourist Visa",
//   //         type: "Multiple Entry",
//   //         validity: "10 Years",
//   //         duration: "6 Months per stay",
//   //         processingTime: "30 Business Days",
//   //         estimatedDate: "25-10-2025",
//   //         price: "₹18500",
//   //         express: false,
//   //         popular: true,
//   //       },
//   //     ],
//   //   },
//   //   {
//   //     id: 7,
//   //     name: "France",
//   //     visaCount: "28K Visas",
//   //     image:
//   //       "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=800&q=80",
//   //     date: "10 Dec, 11:00 AM",
//   //     flag: "🇫🇷",
//   //     description: "Romantic cities, exquisite cuisine, and rich art history",
//   //     visaTypes: [
//   //       {
//   //         id: 1,
//   //         name: "Schengen Tourist Visa",
//   //         type: "Multiple Entry",
//   //         validity: "90 Days",
//   //         duration: "90 Days",
//   //         processingTime: "15 Business Days",
//   //         estimatedDate: "10-10-2025",
//   //         price: "₹8500",
//   //         express: false,
//   //         popular: true,
//   //       },
//   //     ],
//   //   },
//   //   {
//   //     id: 8,
//   //     name: "United Arab Emirates",
//   //     visaCount: "35K Visas",
//   //     image:
//   //       "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=800&q=80",
//   //     date: "11 Dec, 01:45 PM",
//   //     flag: "🇦🇪",
//   //     description:
//   //       "Modern architecture, luxury shopping, and desert adventures",
//   //     visaTypes: [
//   //       {
//   //         id: 1,
//   //         name: "30 Days Tourist Visa",
//   //         type: "Single Entry",
//   //         validity: "30 Days",
//   //         duration: "30 Days",
//   //         processingTime: "5 Business Days",
//   //         estimatedDate: "28-09-2025",
//   //         price: "₹3500",
//   //         express: false,
//   //         popular: true,
//   //       },
//   //     ],
//   //   },
//   // ];

//   // Fetch countries from API
//   // Fetch countries from API
//   useEffect(() => {
//     const fetchCountries = async () => {
//       try {
//         setLoading(true);
//         setError(null);

//         const response = await fetch(
//           `${import.meta.env.VITE_URL}/api/admin/visa-info`,
//           { headers: { Accept: "application/json" } }
//         );

//         if (!response.ok) throw new Error("API Error");

//         const data = await response.json();

//         // 🟢 API contains array inside data.visas
//         const transformedData = data.visas.map((item, idx) => ({
//           id: item._id || idx,
//           name: item.country,
//           flag: item.flag,
//           image: `${import.meta.env.VITE_URL}/${item.image}`, // full path
//           visaCount: item.visaCount,
//           description: item.description,

//           visaTypes: item.visaType || [],

//           // Mapped Stats
//           stats: {
//             countriesCovered: item.countryCovered,
//             visasProcessed: item.visaProcess,
//             successRate: item.successRate,
//             avgProcessingTime: item.averageProcessingTime,
//           },
//         }));

//         setCountries(transformedData);
//       } catch (err) {
//         console.error("API Fetch Failed:", err);
//         setError("Failed to load visa countries");
//         setCountries([]); // 🛑 No static data
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCountries();
//   }, []);

//   // ⭐ Responsive CardsToShow (Mobile:1, Tablet:2, Desktop:4)
//   useEffect(() => {
//     const updateCardsToShow = () => {
//       if (window.innerWidth < 640) setCardsToShow(1);
//       else if (window.innerWidth < 1024) setCardsToShow(2);
//       else setCardsToShow(4);
//     };

//     updateCardsToShow();
//     window.addEventListener("resize", updateCardsToShow);

//     return () => window.removeEventListener("resize", updateCardsToShow);
//   }, []);

//   // Auto-play functionality
//   useEffect(() => {
//     if (!autoPlay || countries.length === 0) return;

//     const interval = setInterval(() => {
//       if (currentIndex < countries.length - cardsToShow) {
//         setCurrentIndex((prev) => prev + 1);
//       } else {
//         setCurrentIndex(0);
//       }
//     }, 3000);

//     return () => clearInterval(interval);
//   }, [currentIndex, autoPlay, countries.length, cardsToShow]);

//   const nextSlide = () => {
//     if (currentIndex < countries.length - cardsToShow) {
//       setCurrentIndex((prev) => prev + 1);
//     } else {
//       setCurrentIndex(0);
//     }
//   };

//   const prevSlide = () => {
//     if (currentIndex > 0) {
//       setCurrentIndex((prev) => prev - 1);
//     } else {
//       setCurrentIndex(countries.length - cardsToShow);
//     }
//   };

//   const handleCardClick = (country) => {
//     setSelectedCountry(country);
//     setIsModalOpen(true);
//   };

//   // const visibleCountries = countries.slice(
//   //   currentIndex,
//   //   currentIndex + cardsToShow
//   // );

//   const visibleCountries = countries.slice(
//     currentIndex,
//     currentIndex + cardsToShow
//   );

//   const totalCards = countries.length;

//   // Stats data - either from API or default
//   const statsData = countries[0]?.stats
//     ? [
//         {
//           label: "Countries Covered",
//           value: countries[0].stats.countriesCovered || "150+",
//         },
//         {
//           label: "Visas Processed",
//           value: countries[0].stats.visasProcessed || "500K+",
//         },
//         {
//           label: "Success Rate",
//           value: countries[0].stats.successRate || "98.7%",
//         },
//         {
//           label: "Avg Processing Time",
//           value: countries[0].stats.avgProcessingTime || "3-5 Days",
//         },
//       ]
//     : [
//         { label: "Countries Covered", value: "150+" },
//         { label: "Visas Processed", value: "500K+" },
//         { label: "Success Rate", value: "98.7%" },
//         { label: "Avg Processing Time", value: "3-5 Days" },
//       ];

//   if (loading && countries.length === 0) {
//     return (
//       <section className="py-8 md:py-10 bg-gradient-to-br from-blue-50 to-white">
//         <div className="container mx-auto px-4 md:px-8">
//           <div className="flex justify-center items-center h-64">
//             <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
//           </div>
//         </div>
//       </section>
//     );
//   }

//   return (
//     <>
//       <section className="py-8 md:py-10 bg-gradient-to-br from-blue-50 to-white">
//         <div className="container mx-auto px-4 md:px-8">
//           {/* Error Message */}
//           {error && (
//             <div className="mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
//               <p className="text-yellow-700">{error}</p>
//             </div>
//           )}

//           {/* Section Header */}
//           <div className="text-center mb-8">
//             <motion.div
//               initial={{ opacity: 0, y: -20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
//                 Explore Visa Options by Country
//               </h2>
//               <p className="text-gray-600 text-lg max-w-2xl mx-auto">
//                 Select a country to view visa types, requirements & processing
//                 time.
//               </p>
//               {/* <p className="text-sm text-gray-500 mt-2">
//                 Showing {countries.length} countries
//               </p> */}
//             </motion.div>
//           </div>

//           {/* Slider Container */}
//           <div
//             className="relative"
//             onMouseEnter={() => setAutoPlay(false)}
//             onMouseLeave={() => setAutoPlay(true)}
//           >
//             {/* Prev Button */}
//             {countries.length > cardsToShow && (
//               <button
//                 onClick={prevSlide}
//                 className="absolute -left-4 md:-left-9 top-1/2 transform -translate-y-1/2 z-10 bg-blue-500/90 backdrop-blur-sm p-3 rounded-full shadow-lg hover:bg-blue-600 cursor-pointer hover:shadow-xl transition-all duration-300 hover:scale-110 disabled:opacity-30 disabled:cursor-not-allowed"
//                 disabled={currentIndex === 0}
//               >
//                 <FiChevronLeft className="text-2xl text-gray-100" />
//               </button>
//             )}

//             {/* Next Button */}
//             {countries.length > cardsToShow && (
//               <button
//                 onClick={nextSlide}
//                 className="absolute -right-4 md:-right-9 top-1/2 transform -translate-y-1/2 z-10 bg-blue-500/90 backdrop-blur-sm p-3 rounded-full shadow-lg hover:bg-blue-600 cursor-pointer hover:shadow-xl transition-all duration-300 hover:scale-110 disabled:opacity-30 disabled:cursor-not-allowed"
//                 disabled={currentIndex >= countries.length - cardsToShow}
//               >
//                 <FiChevronRight className="text-2xl text-gray-100" />
//               </button>
//             )}

//             {/* Cards Grid */}
//             {countries.length === 0 ? (
//               <div className="text-center py-12">
//                 <p className="text-gray-500">
//                   No countries available. Please add some countries from the
//                   admin panel.
//                 </p>
//               </div>
//             ) : (
//               <>
//                 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
//                   {visibleCountries.map((country, index) => (
//                     <motion.div
//                       key={country.id}
//                       initial={{ opacity: 0, y: 20 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       transition={{ delay: index * 0.1 }}
//                       whileHover={{
//                         scale: 1.03,
//                         transition: { duration: 0.2 },
//                       }}
//                       className="cursor-pointer group"
//                       onClick={() => setSelectedCountry(country)}
//                     >
//                       <div className="rounded-3xl overflow-hidden shadow-lg bg-white hover:shadow-2xl transition-all duration-300 h-full">
//                         <div className="relative h-48 overflow-hidden">
//                           <motion.img
//                             src={country.image}
//                             alt={country.name}
//                             className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
//                             loading="lazy"
//                           />

//                           {/* Gradient */}
//                           <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />

//                           {/* Flag */}
//                           <div className="absolute top-3 left-3 bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-lg">
//                             {country.flag}
//                           </div>

//                           {/* Visa Count */}
//                           <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm px-4 py-1.5 rounded-full text-sm font-semibold shadow-md">
//                             {country.visaCount}
//                           </div>

//                           {/* Heart */}
//                           <motion.button
//                             className="absolute bottom-3 right-3 bg-white/90 backdrop-blur-sm p-2.5 rounded-full shadow-md hover:bg-white"
//                             whileHover={{ scale: 1.1 }}
//                             whileTap={{ scale: 0.9 }}
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               // Add to favorites logic here
//                             }}
//                           >
//                             <FiHeart className="text-gray-700 text-lg" />
//                           </motion.button>

//                           {/* Name */}
//                           <div className="absolute bottom-3 left-3 text-white">
//                             <h3 className="text-xl font-bold drop-shadow-lg">
//                               {country.name}
//                             </h3>
//                           </div>
//                         </div>

//                         {/* Content */}
//                         <div className="p-5">
//                           <div className="flex justify-between items-center mb-4">
//                             <p className="text-gray-600 text-lg font-bold line-clamp-2">
//                               {country.description}
//                             </p>

//                             <span className="text-sm whitespace-nowrap px-2 py-1 rounded-md bg-gray-100 text-gray-600 hover:bg-blue-100 hover:text-blue-700 transition-all cursor-pointer">
//                               {country.visaTypes?.length || 0} visa types
//                             </span>
//                           </div>

//                           <div className="flex items-center justify-between">
//                             <div className="whitespace-nowrap">
//                               <p className="text-xs text-gray-500">
//                                 Processing Time{" "}
//                                 {country.visaTypes[0]?.processingTime || "N/A"}
//                               </p>
//                               {/* <p className="text-sm font-semibold text-blue-600">
//                                 {new Date(country.date).toLocaleDateString(
//                                   "en-US",
//                                   {
//                                     month: "short",
//                                     day: "numeric",
//                                     year: "numeric",
//                                   }
//                                 )}
//                               </p> */}
//                             </div>

//                             <div className="flex md:ml-2 items-center gap-2">
//                               <motion.button
//                                 whileHover={{ scale: 1.05 }}
//                                 whileTap={{ scale: 0.95 }}
//                                 className="px-3 py-2 whitespace-nowrap bg-blue-50 text-blue-600 font-semibold rounded-lg hover:bg-blue-100 transition-colors text-sm"
//                               >
//                                 View Details
//                               </motion.button>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </motion.div>
//                   ))}
//                 </div>

//                 {/* Dots */}
//                 {countries.length > cardsToShow && (
//                   <div className="flex justify-center mt-8 space-x-2">
//                     {Array.from({
//                       length: Math.max(1, totalCards - cardsToShow + 1),
//                     }).map((_, index) => (
//                       <button
//                         key={index}
//                         onClick={() => setCurrentIndex(index)}
//                         className={`w-2 h-2 rounded-full transition-all duration-300 ${
//                           index === currentIndex
//                             ? "w-8 bg-blue-600"
//                             : "bg-gray-300 hover:bg-gray-400"
//                         }`}
//                       />
//                     ))}
//                   </div>
//                 )}
//               </>
//             )}
//           </div>

//           {/* Stats Section */}
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ delay: 0.5 }}
//             className="mt-6 pt-8 border-t border-gray-200"
//           >
//             <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
//               {statsData.map((stat, index) => (
//                 <div key={index} className="text-center p-4">
//                   <div className="text-2xl md:text-3xl font-bold text-blue-600">
//                     {stat.value}
//                   </div>
//                   <div className="text-gray-600 text-sm mt-1">{stat.label}</div>
//                 </div>
//               ))}
//             </div>
//           </motion.div>
//         </div>
//       </section>

//       {/* Modal */}
//       <VisaDetailsModal
//         selectedCountry={selectedCountry}
//         onClose={() => setSelectedCountry(null)}
//       />
//     </>
//   );
// };

// export default CountryCardsSection;
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FiHeart } from "react-icons/fi";
import VisaDetailsModal from "./VisaDetailsModal";

const CountryCardsSection = () => {
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch countries from API
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch(
          `${import.meta.env.VITE_URL}/api/admin/visa-info`,
          { headers: { Accept: "application/json" } }
        );

        if (!response.ok) throw new Error("API Error");

        const data = await response.json();

        // 🟢 API contains array inside data.visas
        const baseUrl = import.meta.env.VITE_URL || "";
        const transformedData = data.visas.map((item, idx) => ({
          id: item._id || idx,
          name: item.country,
          flag: item.flag,
          image: item.image && item.image.startsWith("http") ? item.image : `${baseUrl}/${(item.image || "").replace(/\\/g, "/")}`,
          visaCount: item.visaCount,
          description: item.description,
          visaTypes: item.visaType || [],
          // Mapped Stats
          stats: {
            countriesCovered: item.countryCovered,
            visasProcessed: item.visaProcess,
            successRate: item.successRate,
            avgProcessingTime: item.averageProcessingTime,
          },
        }));

        setCountries(transformedData);
      } catch (err) {
        console.error("API Fetch Failed:", err);
        setError("Failed to load visa countries");
        setCountries([]); // 🛑 No static data
      } finally {
        setLoading(false);
      }
    };

    fetchCountries();
  }, []);

  // Stats data - either from API or default
  const statsData = countries[0]?.stats
    ? [
        {
          label: "Countries Covered",
          value: countries[0].stats.countriesCovered || "150+",
        },
        {
          label: "Visas Processed",
          value: countries[0].stats.visasProcessed || "500K+",
        },
        {
          label: "Success Rate",
          value: countries[0].stats.successRate || "98.7%",
        },
        {
          label: "Avg Processing Time",
          value: countries[0].stats.avgProcessingTime || "3-5 Days",
        },
      ]
    : [
        { label: "Countries Covered", value: "150+" },
        { label: "Visas Processed", value: "500K+" },
        { label: "Success Rate", value: "98.7%" },
        { label: "Avg Processing Time", value: "3-5 Days" },
      ];

  if (loading && countries.length === 0) {
    return (
      <section className="py-8 md:py-10 bg-gradient-to-br from-blue-50 to-white">
        <div className="container mx-auto px-4 md:px-8">
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="py-8 md:py-10 bg-gradient-to-br from-blue-50 to-white">
        <div className="container mx-auto px-4 md:px-8">
          {/* Error Message */}
          {error && (
            <div className="mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
              <p className="text-yellow-700">{error}</p>
            </div>
          )}

          {/* Section Header */}
          <div className="text-center mb-8">
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
                Explore Visa Options by Country
              </h2>
              <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                Select a country to view visa types, requirements & processing
                time.
              </p>
            </motion.div>
          </div>

          {/* Countries Grid - No Slider */}
          {countries.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-gray-500">
                No countries available. Please add some countries from the admin
                panel.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {countries.map((country, index) => (
                <motion.div
                  key={country.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  whileHover={{
                    scale: 1.03,
                    transition: { duration: 0.2 },
                  }}
                  className="cursor-pointer group"
                  onClick={() => setSelectedCountry(country)}
                >
                  <div className="rounded-3xl overflow-hidden shadow-lg bg-white hover:shadow-2xl transition-all duration-300 h-full">
                    <div className="relative h-48 overflow-hidden">
                      <motion.img
                        src={country.image || ""}
                        alt={country.name}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                        loading="lazy"
                      />

                      {/* Gradient */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />

                      {/* Flag */}
                      {/* <div className="absolute top-3 left-3 bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-lg">
                        {country.flag}
                      </div> */}

                      {/* Visa Count */}
                      <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm px-4 py-1.5 rounded-full text-sm font-semibold shadow-md">
                        {country.visaCount}
                      </div>

                      {/* Heart */}
                      {/* <motion.button
                        className="absolute bottom-3 right-3 bg-white/90 backdrop-blur-sm p-2.5 rounded-full shadow-md hover:bg-white"
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          // Add to favorites logic here
                        }}
                      >
                        <FiHeart className="text-gray-700 text-lg" />
                      </motion.button> */}

                      {/* Name */}
                      <div className="absolute bottom-3 left-3 text-white">
                        <h3 className="text-xl font-bold drop-shadow-lg">
                          {country.name}
                        </h3>
                      </div>
                    </div>

                    {/* Content */}
                    <div className="p-5">
                      <div className="flex justify-between items-center mb-4">
                        <p className="text-gray-600 text-lg font-bold line-clamp-2">
                          {country.description}
                        </p>

                        <span className="text-sm whitespace-nowrap px-2 py-1 rounded-md bg-gray-100 text-gray-600 hover:bg-blue-100 hover:text-blue-700 transition-all cursor-pointer">
                          {country.visaTypes?.length || 0} visa types
                        </span>
                      </div>

                      <div className="flex items-center justify-between">
                        <div className="whitespace-nowrap">
                          <p className="text-xs text-gray-500">
                            Processing Time{" "}
                            {country.visaTypes[0]?.processingTime || "N/A"}
                          </p>
                        </div>

                        <div className="flex md:ml-2 items-center gap-2">
                          <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            className="px-3 py-2 whitespace-nowrap bg-blue-50 text-blue-600 font-semibold rounded-lg hover:bg-blue-100 transition-colors text-sm"
                          >
                            View Details
                          </motion.button>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          )}

          {/* Stats Section */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="mt-12 pt-8 border-t border-gray-200"
          >
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {statsData.map((stat, index) => (
                <div key={index} className="text-center p-4">
                  <div className="text-2xl md:text-3xl font-bold text-blue-600">
                    {stat.value}
                  </div>
                  <div className="text-gray-600 text-sm mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Modal */}
      <VisaDetailsModal
        selectedCountry={selectedCountry}
        onClose={() => setSelectedCountry(null)}
      />
    </>
  );
};

export default CountryCardsSection;